// TanStack Query cache keys, in one place (the live channel writes into the same keys).
export const KEYS = {
  me: ['me'],
  clock: ['clock'],
  settings: ['settings'],
  shipments: ['shipments'],
  nextSrb: ['next-srb'],
  finance: ['finance'],
  activity: ['activity'],
  cards: ['cards'],
  quotations: ['quotations'],
  messages: ['messages'],
  vaultDates: ['vault-dates'],
  tasks: ['tasks'],
  brain: ['brain'],
  version: ['version'],
  documents: ['documents'],
  pushStatus: (endpoint: string) => ['push-status', endpoint],
} as const;
